export default __webpack_public_path__ + "static/core-menu-a9f19b29c53c2a81a469d9b191e776ad.png";